// utils/sanitizeForecastData.js
import { sanitizeText } from '../../lib/sanitize';

export const sanitizeForecastData = (data) => {
  const clean = { ...data };

  // Удаляем поля, которых не должно быть в прогнозе
  delete clean.isChallenge;
  delete clean.creatorBet;
  delete clean.outcome;

  // Нормализация newsLinks
  if (Array.isArray(clean.newsLinks)) {
    clean.newsLinks = clean.newsLinks.filter(
      (link) => typeof link === 'string' && link.trim() !== ''
    );
  } else {
    clean.newsLinks = [];
  }

  // Проверка images (если не массив — удаляем)
  if (clean.images && !Array.isArray(clean.images)) {
    delete clean.images;
  }

  // ---- НОВОЕ: sanitize positionSnapshot ----
  if (clean.positionSnapshot && typeof clean.positionSnapshot === 'object') {
    const ps = clean.positionSnapshot || {};
    const side = String(ps.side || '').toLowerCase();
    clean.positionSnapshot = {
      symbol: sanitizeText(ps.symbol, 12),
      side: ['long', 'short'].includes(side) ? side : 'long',
      leverage: Number(ps.leverage || 1),
      qty: Number(ps.qty || 0),
      entry: Number(ps.entry || 0),
      mark: Number(ps.mark || 0),
      liq: ps.liq == null ? null : Number(ps.liq),
      margin: Number(ps.margin || 0),
      source: sanitizeText(ps.source || 'terminal', 24),
      ts: Number(ps.ts || Date.now()),
    };
  } else {
    delete clean.positionSnapshot; // чтобы не было пустых структур
  }

  // Удаляем null/undefined/пустые строки и пустые массивы
  return Object.fromEntries(
    Object.entries(clean).filter(([_, value]) =>
      value !== null &&
      value !== undefined &&
      (typeof value !== 'string' || value.trim() !== '') &&
      (!Array.isArray(value) || value.length > 0)
    )
  );
};
